var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"auto-overflow-scroll",rawName:"v-auto-overflow-scroll",value:(_vm.open && _vm.overflowScroll),expression:"open && overflowScroll"}],staticClass:"context",class:{
    'visibility-hidden': !_vm.open || !_vm.updatedOnce,
    'context--overflow-scroll': _vm.overflowScroll,
  }},[(_vm.openedOnce)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }